import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { LoaderService, SessionManagerService } from '../services/index';
import { Router } from '@angular/router';
import { ADMIN } from '../constant/routes';

@Injectable({
  providedIn: 'root',
})
export class SiteAdminSessionGuard implements CanActivate {
  constructor(
    private router: Router,
    private sessionManagerService: SessionManagerService,
    private loader: LoaderService,
  ) {}
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    const { roleId = '' } = this.sessionManagerService.getTokenAndRole();
    if (roleId && roleId === '4') {
      const SiteAdminLoggedAt = localStorage.getItem('SiteAdminLoggedAt');
      if (SiteAdminLoggedAt) {
        const storedTimestamp = parseInt(SiteAdminLoggedAt, 10);
        const currentTimestamp = Date.now();
        const timeDifference = currentTimestamp - storedTimestamp;
        // Convert time difference to minutes
        const timeDifferenceInHours = Math.floor(timeDifference / (1000 * 60 * 60));
        if (timeDifferenceInHours >= 12) {
          this.sessionManagerService.logout();
          this.router.navigate([ADMIN.URL]);
          return false;
        }
      }
    }
    return true;
  }
}
